// extracted by mini-css-extract-plugin
export default {"cardInstance":"card_cardInstance__gdK4R","cardContainer":"card_cardContainer__jjYB9"};